var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m17.67 9.86-3.53-3.53a.5.5 0 0 0-.71 0l-9.55 9.54L3 20.38a.5.5 0 0 0 .58.58l4.51-.84 9.54-9.55a.5.5 0 0 0 .04-.71Zm.5-6.497 2.474 2.475a1.25 1.25 0 0 1 0 1.767l-.884.884a.5.5 0 0 1-.707 0l-3.535-3.535a.5.5 0 0 1 0-.707l.884-.884a1.25 1.25 0 0 1 1.767 0Z"
})));
export default SvgEdit;